module.exports = __webpack_public_path__ + "img/following-step06.ca16408f.svg";